import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ChannelCategoryService } from '../service/channel-category.service';

@Injectable({
    providedIn: 'root'
})
export class ChannelValidators
{
    constructor(private channelCategoryService: ChannelCategoryService) { }

    public validateChannelCategoryNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.channelCategoryService.existsChannelCategoryName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
